import axios from "axios";

// Centralized base URL for backend (configurable via env)
// const baseUrl = process.env.REACT_APP_API_BASE_URL || "dial.diax.in:8080";
// const baseUrl = process.env.REACT_APP_API_BASE_URL || "dial.diax.ai";
// const baseUrl =  "dial.diax.ai";
// const baseUrl =  "diabrain.diax.in:8080";
const baseUrl = "diabrain.diax.ai";
const apiClient = axios.create({
  baseURL: `https://${baseUrl}`,
});

// Simple in-memory caches for current session
let cachedCrn = null;
let cachedUserProfile = null;
let cachedUserDetails = null;
let cachedPayments = null;

export const getBaseUrl = () => baseUrl;

// Helpers to refresh cached API responses after mutations (like payments).
export const clearCrnCache = () => {
  cachedCrn = null;
};

export const clearUserProfileCache = () => {
  cachedUserProfile = null;
};

export const clearUserDetailsCache = () => {
  cachedUserDetails = null;
};

export const clearPaymentsCache = () => {
  cachedPayments = null;
};

export const clearAllCaches = () => {
  cachedCrn = null;
  cachedUserProfile = null;
  cachedUserDetails = null;
  cachedPayments = null;
};

export const fetchCrn = async () => {
  if (cachedCrn) return cachedCrn;
  const response = await apiClient.post("/request", { object: "crn", qdn: "diabrain" });
  if (response.data?.crn) {
    cachedCrn = response.data.crn;
    return cachedCrn;
  }
  throw new Error("CRN not found in response");
};

export const fetchUserDetails = async (user_id, crn) => {
  if (cachedUserDetails && cachedUserDetails.user_id === user_id) {
    return cachedUserDetails;
  }
  const payload = {
    user_id,
    crn,
    object: "users",
    action: "R",
  };
  const response = await apiClient.post("/request", payload);
  cachedUserDetails = { user_id, raw: response.data };
  return cachedUserDetails;
};

export const fetchProfile = async (user_id, crn) => {
  if (cachedUserProfile && cachedUserProfile.user_id === user_id) {
    return cachedUserProfile;
  }
  const payload = {
    crn,
    user_id,
    object: "profile",
    action: "R",
  };
  const response = await apiClient.post("/request", payload);
  cachedUserProfile = { user_id, raw: response.data };
  return cachedUserProfile;
};

export const fetchPayments = async (user_id, crn) => {
  if (cachedPayments && cachedPayments.user_id === user_id) {
    return cachedPayments;
  }
  const payload = {
    user_id,
    object: "payments",
    action: "R",
  };
  const response = await apiClient.post("/request", payload);
  cachedPayments = { user_id, raw: response.data };
  return cachedPayments;
};

export const postRequest = (payload) => apiClient.post("/request", payload);

export const postToPath = (path, payload) => apiClient.post(path, payload);

